import React, {useCallback} from 'react';
import {createPathOfBaselinesComparisonPage} from 'features/Baselines/BaselineComparisonPage/BaselineComparisonPage.utils';
import {NavigateFunction, useNavigate} from 'react-router-dom';
import {PrimaryButtonCompat as PrimaryButton} from 'components/FluentUICompat';
import {useTranslationsOfBaselinesSelectionDialog} from './BaselinesSelectionDialog.utils';
import {
	ProjectDetailsPageParams,
	encodeGenAndModelSeries,
} from 'features/VehicleProjects/vehicleProjectPagePaths';

export interface PropsOfBtnToCompareBaselines {
	params: ProjectDetailsPageParams;
	baseline1Id: string | null;
	baseline2Id: string | null;
}

export function BtnToCompareBaselines({
	params,
	baseline1Id,
	baseline2Id,
}: PropsOfBtnToCompareBaselines): React.ReactElement {
	const navigate: NavigateFunction = useNavigate();
	const {t} = useTranslationsOfBaselinesSelectionDialog();

	const navigateToComparisonPage = useCallback((): void => {
		if (!baseline2Id) throw new Error('No baseline was selected');
		const encodedGenAndModel: ProjectDetailsPageParams =
			encodeGenAndModelSeries(params);

		const path: string = createPathOfBaselinesComparisonPage({
			baselineId: baseline1Id!,
			idOfBaselineToCompareTo: baseline2Id!,
			...encodedGenAndModel,
		});
		navigate(path);
	}, [params, navigate, baseline1Id, baseline2Id]);

	return (
		<PrimaryButton
			onClick={navigateToComparisonPage}
			disabled={!baseline1Id || !baseline2Id}
		>
			{t('SaveBtn')}
		</PrimaryButton>
	);
}
